import React from "react";
import mobileI from '../../images/home/mobile-app.png';

function MobileApplication() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={mobileI}
                alt="Mobile Application"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Put Your Business In Your Customers' Hands</h2>

                <p>
                  Mobile applications can provide customers and employees
                  with convenient access to services, information, and business
                  processes.
                </p>

                <p>
                  We develop mobile solutions based on your requirements,
                  target users, and business objectives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Features />
      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">
          <h1>Mobile Applications</h1>
          <p style={{ color: '#FF7D37' }}>
            Mobile solutions that make your services &<br /> business processes
            accessible wherever your users are.
          </p>
        </div>
      </div>
    </section>
  );
}

function Features() {
  return (
    <section className="service-features-section">
      <div className="container">
        <div className="section-heading text-center">
          <h2>Applications Designed For Users</h2>
        </div>

        <div className="row g-4">
          {[
            ["Customer Applications", "Provide customers with convenient access to your products and services."],
            ["Business Applications", "Give employees mobile access to important business operations."],
            ["Modern Experience", "Create simple and intuitive mobile experiences for your users."]
          ].map(([title, text]) => (
            <div className="col-lg-4 col-md-6" key={title}>
              <div className="service-feature-card">
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>MOBILE SOLUTIONS</span>
            <h2>Have A Mobile App Idea?</h2>
            <p>Let's discuss your requirements and project goals.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default MobileApplication;